// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__y5LlW","label":"Checkbox_label__0fcaG","labelText":"Checkbox_labelText__VlfHb"};